<template lang="pug">
div.attachment-list-wrapper(v-if="attachments && attachments.length > 0")
  label Message attachments:
  ul.attachment-list
    template(v-for="(attachment, index) in attachments")
      li
        button.attachment(
          title="Click to remove attachment"
          @click="removeAttachment(index)")
          span.content(v-if="attachment.type === 'ACTIVITY'") {{ attachment.content }}
          span.content(v-if="attachment.type === 'EXTERNAL_LINK'")
            template(v-if="attachment.title") {{ attachment.title }} -&nbsp;
            | {{ attachment.content }}
          span.content(v-if="attachment.type === 'INTERNAL_LINK'") Internal link - {{ attachment.content }}
          span.close-icon ✖
</template>
<script>
export default {
  name: 'AttachmentList',
  props: ['attachments'],
  methods: {
    removeAttachment(index) {
      let newAttachments = this.attachments;
      newAttachments.splice(index, 1);

      this.$emit('update-attachments', newAttachments);
    }
  }
};
</script>
<style lang="scss" scoped>
.attachment-list-wrapper {
  .attachment-list {
    li {
      margin-bottom: 3px;
      max-width: 100%;
      background-color: #fff;
      padding: 0;
      border: 1px solid #ddd;

      &:last-child {
        margin-bottom: 0;
      }
    }

    button.attachment {
      text-align: left;
      display: flex;
      width: 100%;
      padding: 3px 6px 2px;
      background-color: transparent;
      cursor: pointer;

      .content {
        display: inline-block;
        font-size: $ms-down1 - 0.05em;
        align-self: center;
        flex-grow: 1;
        overflow: hidden;
        white-space: nowrap;
        color: #333;
      }
      .close-icon {
        font-size: 0.9em;
        height: auto;
        width: 20px;
        color: #f00;
        text-align: right;
        margin: 0 0 0 15px;
        align-self: center;
        padding-top: 0.5px;
      }
    }
  }
}
</style>
